import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table17Data = { [key: string]: Table17Row };

export interface ITable17Props {
  data: Table17Data;
}

interface ITable17State {
}

export interface Table17Row {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

const sortOrder = [
  "No Automation",
  "Driver Assistance",
  "Partial Automation",
  "Conditional Automation",
  "High Automation",
  "Full Automation",
  "Automation Level Unknown",
  "Unknown",
  "Not Stated",
];

export default class Table17Summary extends React.Component<ITable17Props, ITable17State> {
  constructor(props: ITable17Props) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      this.props.data ?
        <table className="ss-table summaryTable1">
          <colgroup>
            <col style={{ width: '50%' }} />
            <col span={6} style={{ width: '8.3%' }} />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={2} className="border-right-bold">
                <div className="ss-table-header">
                  <span className="header-number">17</span>
                  <span className="header-text">AUTOMATION LEVEL ENGAGED AT TIME OF CRASH</span>
                </div>
              </th>
              <th rowSpan={2}>TOTAL</th>
              <th rowSpan={2}>FATAL</th>
              <th colSpan={3}>INJURY</th>
              <th rowSpan={2}>PDO **</th>
            </tr>
            <tr>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
            </tr>
          </thead>
          <tbody>
            {sortBasedOnList(this.props.data, sortOrder).map((key) =>
              <tr key={key}>
                <td className="border-right-bold">{key}</td>
                <td className="numberTotals">{this.props.data[key].total}</td>
                <td className="numberTotals">{this.props.data[key].fatal}</td>
                <td className="numberTotals">{this.props.data[key].injuryA}</td>
                <td className="numberTotals">{this.props.data[key].injuryB}</td>
                <td className="numberTotals">{this.props.data[key].injuryC}</td>
                <td className="numberTotals">{this.props.data[key].pdo}</td>
              </tr>
            )}
          </tbody>
        </table>
        : <p>Loading...</p>
    );
  }
}
